export const featureCards = [
    {
        button: {
            text: 'GO',
            link: '/training-and-job-aids/elearnings/search',
        },
        icon: {
            source: '/img/productsIcons/hat.svg',
            alt: 'financial icon',
        },
        title: 'eLearning',
        subtitle: 'Access product and technical training training to help you be more productive.',
    },
    {
        button: {
            text: 'GO',
            link: '/training-and-job-aids/job-aids',
        },
        icon: {
            source: '/img/productsIcons/lamp.svg',
            alt: 'Financial icon',
        },
        title: 'Job Aids',
        subtitle: 'Resources to help you learn about our products and navigate our systems.',
    },
    {
        button: {
            text: 'GO',
            link: '/training-and-job-aids/webinars/search',
        },
        icon: {
            source: '/img/productsIcons/online-education.svg',
            alt: 'Financial icon',
        },
        title: 'Live Webinars',
        subtitle: 'Attend instructor-led sessions about a variety of topics from the comfort of your desk.',
    },
    // {
    //     button: {
    //         text: 'GO',
    //         link: 'https://www.foremostagent.com/vth',
    //     },
    //     icon: {
    //         source: '/img/productsIcons/play-button.svg',
    //         alt: 'Video player icon',
    //     },
    //     title: 'Reimagine Foremost Virtual Events',
    //     subtitle: 'Register for upcoming virtual events and reimagine how we can help boost your business.',
    // },
];

